export const MARKET_ACL_OBJECTS = [
    'MarketNewComponent',
    'MarketDetailComponent',
    'MarketListComponent'
];
